import { ArrowRight, Copy } from 'lucide-react';
import SW from '../../assets/images/sw-2.png';
import { Link } from 'react-router-dom';

const CountryCard = ({
  country,
  miningData,
  contribution,
  logo,
  link,
}: any) => {
  return (
    <div className='w-full max-w-96 border border-[#EBF0FC] rounded-3xl p-6 flex relative  flex-col gap-8'>
      <div className='relative flex flex-col gap-6'>
        <img
          src={logo}
          alt=''
          className='object-center w-full max-w-[170px] z-30'
        />

        <div className='flex flex-col gap-3 mt-3'>
          <h2 className='text-3xl text-[#333333] font-Poppins font-semibold z-30'>
            {country}
          </h2>

          <div className='flex  items-center'>
            <div className='flex w-full gap-0.5  text-slate-500 font-normal text-sm items-center'>
              <span className='text-nowrap truncate text-left'>
                {miningData}
              </span>
            </div>
            <div className='flex w-full gap-0.5  text-slate-500 text-right font-normal text-sm  items-center '>
              <span className='text-nowrap truncate'>{contribution}</span>
            </div>
          </div>
        </div>
      </div>
      <Link
        type='button'
        to={link}
        className=' flex justify-center transition-all items-center border border-[#012169] hover:bg-[#012169] hover:text-white py-3 px-6 rounded-xl  w-full text-[#012169] text-[18px] font-Inter'
      >
        Explore Country <ArrowRight size={16} className='ml-2' />
      </Link>
      <img src={SW} className='absolute right-0 top-0 object-center' />
    </div>
  );
};

export default CountryCard;
